'use strict';
'use es6';
/* eslint react/jsx-handler-names: 0 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _underscore = require('../utils/underscore');

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _ActiveElement = require('../core/ActiveElement');

var _ComponentWithWindowListeners = require('../mixins/ComponentWithWindowListeners');

var _ComponentWithWindowListeners2 = _interopRequireDefault(_ComponentWithWindowListeners);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactUtils = require('react-utils');

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _Selectors = require('../constants/Selectors');

var _Style = require('../core/Style');

var _UICloseButton = require('../button/UICloseButton');

var _UICloseButton2 = _interopRequireDefault(_UICloseButton);

var _UIPopover = require('./UIPopover');

var _UIPopover2 = _interopRequireDefault(_UIPopover);

var _UITooltipContent = require('./UITooltipContent');

var _UITooltipContent2 = _interopRequireDefault(_UITooltipContent);

var _UITooltipHeader = require('./UITooltipHeader');

var _UITooltipHeader2 = _interopRequireDefault(_UITooltipHeader);

var _PlacementConstants = require('./PlacementConstants');

var _Hover = require('./utils/Hover');

var _Functions = require('../core/Functions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var USE_CLASSES = {
  default: 'tooltip-default private-tooltip--default',
  danger: 'tooltip-danger private-tooltip--danger',
  longform: 'private-tooltip--longform'
};

var instanceCount = 0;

var allTooltips = [];

function _setOpen(component, newOpen) {
  if (!component._isMounted) return;
  if (newOpen && component.props.disabled) return;
  if (newOpen === component.props.open) return;

  if (component.props.onOpenChange) {
    component.props.onOpenChange((0, _SyntheticEvent2.default)(newOpen));
  }
}

var UITooltip = _react2.default.createClass({
  displayName: 'UITooltip',

  mixins: [_ComponentWithWindowListeners2.default, _reactAddonsPureRenderMixin2.default],

  propTypes: {
    autoPlacement: _react.PropTypes.bool,
    children: _react.PropTypes.node,
    className: _react.PropTypes.string,
    delay: _react.PropTypes.number.isRequired,
    delayOnHold: _react.PropTypes.number.isRequired,
    disabled: _react.PropTypes.bool.isRequired,
    headingText: _react.PropTypes.node,
    innerClassName: _react.PropTypes.string,
    maxWidth: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
    onClose: _react.PropTypes.func,
    onOpenChange: _react.PropTypes.func,
    open: _react.PropTypes.bool,
    placement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS).isRequired,
    style: _react.PropTypes.object,
    title: _react.PropTypes.node,
    use: _react.PropTypes.oneOf(Object.keys(USE_CLASSES)),
    _bodyElement: _react.PropTypes.instanceOf(HTMLElement)
  },

  getDefaultProps: function getDefaultProps() {
    return {
      autoPlacement: true,
      delay: 300,
      delayOnHold: 100,
      disabled: false,
      open: false,
      placement: 'top',
      use: 'default'
    };
  },
  getInitialState: function getInitialState() {
    return {
      listeningForMouseMove: false
    };
  },
  componentWillMount: function componentWillMount() {
    instanceCount += 1;
    this._tooltipId = 'uiTooltip-' + instanceCount;
    this.setOpen = this.getDelayedSetOpen(this.props.delay);
  },
  componentDidMount: function componentDidMount() {
    allTooltips.push(this);
    this._isMounted = true;
  },
  componentWillReceiveProps: function componentWillReceiveProps(_ref) {
    var delay = _ref.delay;

    if (delay !== this.props.delay) {
      this.setOpen = this.getDelayedSetOpen(delay);
    }
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    var open = this.props.open;

    if (!prevProps.open && open) {
      this.startIntersectionObserver();
      this.addBodyMouseLeaveListener();
      this.closeOtherTooltips();
    } else if (prevProps.open && !open) {
      this.stopIntersectionObserver();
      this.removeBodyMouseLeaveListener();
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    allTooltips.splice(allTooltips.indexOf(this), 1);
    this._isMounted = false;
    this.stopIntersectionObserver();
    this.removeBodyMouseLeaveListener();
  },
  startIntersectionObserver: function startIntersectionObserver() {
    // We use Intersection Observer to try to close the tooltip if its target
    // ceases to be visible to the user, e.g. due to scrolling (issue #1412).
    var _window = window,
        IntersectionObserver = _window.IntersectionObserver;

    if (!IntersectionObserver) {
      return; // No browser support; oh well.
    }
    var targetEl = (0, _reactDom.findDOMNode)(this);
    if (!targetEl) {
      return;
    }
    this._intersectionObserver = new IntersectionObserver(this.handleIntersectionEvent);
    this._intersectionObserver.observe(targetEl);
  },
  stopIntersectionObserver: function stopIntersectionObserver() {
    if (this._intersectionObserver) {
      this._intersectionObserver.disconnect();
      this._intersectionObserver = null;
    }
  },
  handleIntersectionEvent: function handleIntersectionEvent(entries) {
    var intersectionRatio = entries[0].intersectionRatio;

    if (intersectionRatio <= 0) {
      this.closeNow();
    }
  },
  addBodyMouseLeaveListener: function addBodyMouseLeaveListener() {
    if (!document.body) return;
    document.body.addEventListener('mouseleave', this.triggerClose);
  },
  removeBodyMouseLeaveListener: function removeBodyMouseLeaveListener() {
    if (!document.body) return;
    document.body.removeEventListener('mouseleave', this.triggerClose);
  },
  closeOtherTooltips: function closeOtherTooltips() {
    var _this = this;

    allTooltips.forEach(function (tooltip) {
      if (tooltip === _this) return;
      if (tooltip._isMounted && tooltip.props.use !== 'longform') {
        tooltip.closeNow();
      }
    });
  },
  checkValidUse: function checkValidUse(_ref2) {
    var use = _ref2.use;

    if (use === 'longform') {
      _devLogger2.default.warn({
        message: 'UITooltip: `use="longform"` is no longer recommended and may be removed in the ' + 'future. Please use <UIPopover use="longform" /> instead.',
        key: 'UITooltip: longform'
      });
    }
  },
  getDelayedSetOpen: function getDelayedSetOpen(delay) {
    var setOpen = (0, _underscore.partial)(_setOpen, this);
    return delay === 0 ? setOpen : function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return setTimeout(function () {
        return setOpen.apply(undefined, args);
      }, delay);
    };
  },
  getChildren: function getChildren() {
    var children = _react.Children.only(this.props.children);
    var _children$props = children.props,
        onBlur = _children$props.onBlur,
        onFocus = _children$props.onFocus,
        onKeyDown = _children$props.onKeyDown,
        onMouseEnter = _children$props.onMouseEnter,
        onMouseLeave = _children$props.onMouseLeave;


    return (0, _react.cloneElement)(children, {
      'aria-describedby': this._tooltipId,
      onBlur: (0, _Functions.memoizedSequence)(this.handleBlur, onBlur),
      onFocus: (0, _Functions.memoizedSequence)(this.handleFocus, onFocus),
      onKeyDown: (0, _Functions.memoizedSequence)(this.handleKeyDown, onKeyDown),
      onMouseEnter: (0, _Functions.memoizedSequence)(this.handleMouseEnter, onMouseEnter),
      onMouseLeave: (0, _Functions.memoizedSequence)(this.handleMouseLeave, onMouseLeave),
      tabIndex: 0 // https://git.hubteam.com/HubSpot/UIComponents/issues/4949
    });
  },
  getWindowListeners: function getWindowListeners() {
    return {
      mousemove: this.handleWindowMouseMove
    };
  },
  getWindowListenersActive: function getWindowListenersActive() {
    // Ignore window listener events unless we're open
    var listeningForMouseMove = this.state.listeningForMouseMove;

    return listeningForMouseMove;
  },
  isActiveElement: function isActiveElement() {
    var thisEl = (0, _reactDom.findDOMNode)(this);
    return thisEl && thisEl.contains((0, _ActiveElement.getActiveElement)());
  },
  getTooltipClassName: function getTooltipClassName() {
    var _props = this.props,
        className = _props.className,
        use = _props.use;

    return (0, _reactUtils.classNames)(className, USE_CLASSES[use], 'tooltip', 'private-tooltip', 'tooltip-' + use + '-border', 'private-tooltip--' + use + '__border');
  },
  triggerClose: function triggerClose() {
    var onClose = this.props.onClose;

    this.closeNow();
    this._closeOnPopoverFocusLeave = false;
    (0, _Functions.callIfPossible)(onClose);
    this.setState({
      listeningForMouseMove: false
    });
  },
  triggerOpen: function triggerOpen() {
    // Opens the timeout after the delay
    this._openTimeout = this.setOpen(true);
    this._closeOnPopoverFocusLeave = false;
  },
  closeNow: function closeNow() {
    _setOpen(this, false);
  },
  openNow: function openNow() {
    _setOpen(this, true);
  },
  handleKeyDown: function handleKeyDown(evt) {
    // Very special-case, but important for a11y: When we tab out of the tooltip
    // target, the focus moves to the first tabbable element inside of the
    // tooltip (if any). When that happens, we need to prevent the tooltip from
    // closing when the target blur event fires and instead close it when the
    // focus leaves the tooltip content.
    var key = evt.key,
        shiftKey = evt.shiftKey;

    if (key === 'Tab' && !shiftKey) {
      var tooltipEl = document.getElementById(this._tooltipId);
      if (!tooltipEl) {
        return;
      }
      if (tooltipEl.querySelector(_Selectors.FOCUSABLE)) {
        this._closeOnPopoverFocusLeave = true;
      }
    }
  },
  handleBlur: function handleBlur() {
    if (this._closeOnPopoverFocusLeave || !this._wasOpenedByFocus) {
      return;
    }
    if (this.isActiveElement()) {
      // If blur has occurred but document.activeElement still points to the
      // anchor element, it means the entire document has lost focus. See
      // HubSpot/UIComponents#784
      return;
    }
    this.triggerClose();
  },
  handleFocus: function handleFocus() {
    // If the target receives focus and we're not under the mouse cursor, open without delay.
    if (!this.state.listeningForMouseMove) {
      this._wasOpenedByFocus = true;
      this.openNow();
    }
  },
  handlePopoverFocusLeave: function handlePopoverFocusLeave() {
    if (this._closeOnPopoverFocusLeave) {
      this._closeOnPopoverFocusLeave = false;
      this.triggerClose();
    }
  },
  handleCloseButtonClick: function handleCloseButtonClick() {
    // The order is important here: We want to restore focus to the target on
    // close, without the focus event causing a triggerOpen right after.
    var el = (0, _reactDom.findDOMNode)(this);
    if (el) {
      el.focus();
    }
    this.triggerClose();
  },
  handleMouseEnter: function handleMouseEnter() {
    // Workaround for React bug that allows handleMouseEnter to be called twice
    // for the same event (rare but possible!)
    if (this._holdTimeout) {
      return;
    }

    var delayOnHold = this.props.delayOnHold;

    this.triggerOpen();
    this._holdTimeout = setTimeout(this.openNow, delayOnHold);
    this._wasOpenedByFocus = false;
    this.setState({
      listeningForMouseMove: true
    });
  },
  handleMouseLeave: function handleMouseLeave() {
    // If open has been triggered but a delay is in effect, cancel open.
    clearTimeout(this._openTimeout);
    this._openTimeout = null;
    clearTimeout(this._holdTimeout);
    this._holdTimeout = null;

    var _props2 = this.props,
        disabled = _props2.disabled,
        open = _props2.open,
        use = _props2.use;


    if (disabled) {
      this.triggerClose();
    }

    // If we're open (and we're not longform), we need to keep listening to
    // mousemove until the mouse has left the bounds of the tooltip itself.
    // Otherwise, we don't need the listener.
    this.setState({
      listeningForMouseMove: open && use !== 'longform'
    });
  },
  handleWindowMouseMove: function handleWindowMouseMove(evt) {
    if (!this._isMounted) {
      return;
    }

    var _props3 = this.props,
        delayOnHold = _props3.delayOnHold,
        open = _props3.open;

    if (open) {
      // Bail early and often if the target and/or tooltip aren't in the DOM
      var targetEl = (0, _reactDom.findDOMNode)(this);
      if (!targetEl) return;
      var tooltipEl = document.getElementById(this._tooltipId);
      if (!tooltipEl) return;

      var tooltipArea = tooltipEl.getBoundingClientRect();
      var targetArea = targetEl.getBoundingClientRect();

      if ((0, _Hover.shouldTooltipClose)(targetArea, tooltipArea, evt)) {
        this.triggerClose();
      }
    } else if (this._holdTimeout) {
      clearTimeout(this._holdTimeout);
      this._holdTimeout = setTimeout(this.openNow, delayOnHold);
    }
  },
  renderHeading: function renderHeading() {
    var _props4 = this.props,
        headingText = _props4.headingText,
        use = _props4.use;

    if (headingText) {
      return _react2.default.createElement(
        _UITooltipHeader2.default,
        {
          className: (0, _reactUtils.classNames)({
            'private-tooltip--longform__heading': use === 'longform'
          })
        },
        headingText
      );
    }

    return null;
  },
  renderTooltip: function renderTooltip(_ref3) {
    var innerClassName = _ref3.innerClassName,
        title = _ref3.title,
        use = _ref3.use;

    return _react2.default.createElement(
      _UITooltipContent2.default,
      {
        className: (0, _reactUtils.classNames)(innerClassName, 'tooltip-inner', {
          'has--vertical-spacing': use === 'longform'
        })
      },
      use === 'longform' ? this.renderCloseButton() : null,
      this.renderHeading(),
      title
    );
  },
  renderCloseButton: function renderCloseButton() {
    return _react2.default.createElement(_UICloseButton2.default, {
      className: 'private-tooltip__close-button',
      'data-action': 'close',
      onClick: this.handleCloseButtonClick
    });
  },
  render: function render() {
    var _props5 = this.props,
        autoPlacement = _props5.autoPlacement,
        _bodyElement = _props5._bodyElement,
        disabled = _props5.disabled,
        innerClassName = _props5.innerClassName,
        maxWidth = _props5.maxWidth,
        onOpenChange = _props5.onOpenChange,
        open = _props5.open,
        placement = _props5.placement,
        style = _props5.style,
        title = _props5.title,
        use = _props5.use;

    var computedMaxWidth = typeof maxWidth === 'number' ? (0, _Style.remCalc)(maxWidth) : maxWidth;
    this.checkValidUse({ use: use });
    return _react2.default.createElement(
      _UIPopover2.default,
      {
        arrowSize: use === 'longform' ? 'medium' : 'small',
        autoPlacement: autoPlacement,
        _bodyElement: _bodyElement,
        className: this.getTooltipClassName(),
        content: this.renderTooltip({ innerClassName: innerClassName, title: title, use: use }),
        closeOnOutsideClick: true,
        id: this._tooltipId,
        onFocusLeave: this.handlePopoverFocusLeave,
        onOpenChange: onOpenChange,
        open: !disabled && open && title != null,
        placement: placement,
        style: _extends({ maxWidth: computedMaxWidth }, style),
        use: 'unstyled'
      },
      this.getChildren()
    );
  }
});

exports.default = (0, _Controllable2.default)(UITooltip, ['open']);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/tooltip/UITooltip.js
// module id = 44
// module chunks = 0